module.exports = __webpack_public_path__ + "static/img/4495_phase_function_Paper_PointsHejduk_Prediction.8c1901f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4495_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Uu2a
// module chunks = 0